export const headerStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  marginBottom: '16px',
};

export const typeIconStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};
